module.exports = __webpack_public_path__ + "img/yanbao_heisexi_head.c882585c.png";